import { render, staticRenderFns } from "./msgDetail.vue?vue&type=template&id=e27fb0d8&scoped=true&"
import script from "./msgDetail.vue?vue&type=script&lang=js&"
export * from "./msgDetail.vue?vue&type=script&lang=js&"
import style0 from "./msgDetail.vue?vue&type=style&index=0&id=e27fb0d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27fb0d8",
  null
  
)

export default component.exports